import { render, staticRenderFns } from "./TableErrorImportMinusPoint.vue?vue&type=template&id=3197298e&scoped=true"
import script from "./TableErrorImportMinusPoint.vue?vue&type=script&lang=js"
export * from "./TableErrorImportMinusPoint.vue?vue&type=script&lang=js"
import style0 from "./TableErrorImportMinusPoint.vue?vue&type=style&index=0&id=3197298e&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3197298e",
  null
  
)

export default component.exports